import { TableBody, TableCell, TableRow } from '@windmill/react-ui';
import React, { useState } from 'react';
import { FiEye } from 'react-icons/fi';
import Tooltip from 'components/tooltip/Tooltip';
import ViewCityVendorEnquiryModal from 'components/modal/ViewCityVendorEnquiryModal';
import CityVendorRequestServices from 'services/CityVendorServices';

const CityVendorRequestTable = ({ vendor, perpage, currentPage }) => {
	const [selectedVendor, setSelectedVendor] = useState(null);
	const [openModal, setOpenModal] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleViewDetails = async (id) => {
		try {
			setLoading(true);
			const res = await CityVendorRequestServices.getCityVendorRequestById(id);
			if (res.status && res.data) {
				setSelectedVendor(res.data);
				setOpenModal(true); 
			}
		} catch (err) {
			console.error(' Error fetching vendor details:', err);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			{/*   Only the ViewCityVendorEnquiryModal opens */}
			{openModal && (
				<ViewCityVendorEnquiryModal
					data={selectedVendor}
					loading={loading}
					onClose={() => setOpenModal(false)}
				/>
			)}

			<TableBody>
				{vendor?.slice(0, perpage).map((data, index) => (
					<TableRow key={data.id}>
						<TableCell className="text-center text-sm">
							{(currentPage - 1) * perpage + index + 1}
						</TableCell>
						<TableCell className="text-center text-sm">
							{data.company_name}
						</TableCell>
						<TableCell className="text-center text-sm">
							{data.full_name}
						</TableCell>
						<TableCell className="text-center text-sm">
							{data.city_name}
						</TableCell>
						<TableCell className="text-center text-sm">
							{data.state_name}
						</TableCell>

						<TableCell>
							<div className="flex justify-center">
								<button
									onClick={() => handleViewDetails(data.id)}
									className="p-2 cursor-pointer text-gray-400 hover:text-green-600 focus:outline-none"
								>
									<Tooltip
										id={data.id}
										Icon={FiEye}
										title="View Details"
										bgColor="#34D399"
									/>
								</button>
							</div>
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</>
	);
};

export default CityVendorRequestTable;
